import { Delete } from 'lucide-react';

export interface BuyKeypadProps {
  /** Append a digit / decimal point to the amount string. */
  onKey: (key: string) => void;
  /** Remove the last character. */
  onBackspace: () => void;
}

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0'] as const;

/**
 * On-screen numeric keypad for the buy-in popup (ARC-82 §6 — matches the
 * Figma numpad). Emits digit / decimal keystrokes and a backspace so the
 * parent owns the amount string and its parsing.
 */
export function BuyKeypad({ onKey, onBackspace }: BuyKeypadProps) {
  return (
    <div className="grid grid-cols-3 gap-x-2 gap-y-1">
      {KEYS.map((k) => (
        <button
          key={k}
          type="button"
          onClick={() => onKey(k)}
          className="h-12 rounded-card text-2xl font-semibold text-primary bg-transparent hover:bg-surface-muted active:opacity-70 transition-colors"
        >
          {k}
        </button>
      ))}
      <button
        type="button"
        onClick={onBackspace}
        aria-label="Delete"
        className="h-12 flex items-center justify-center rounded-card text-primary/60 bg-transparent hover:bg-surface-muted active:opacity-70 transition-colors"
      >
        <Delete className="size-6" />
      </button>
    </div>
  );
}
